import Vue from "vue";
import Vuex from "vuex";
import VueAxios from "@/plugins/axios";
import i18n from "@/plugins/i18n";
import moment from "moment";

import { auth } from "@/store/auth.module";
import { countries } from "@/store/countries.module";
import { loading } from "@/store/loading.module";
import { recurringDebit } from "@/store/recurringDebit.module";
import { downloads } from "@/store/downloads.module";
import { organizations } from "@/store/organizations.module";
import { transactions } from "@/store/transactions.module";
import { gateways } from "@/store/gateways.module";
import { leads } from "@/store/leads.module";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    auth,
    countries,
    loading,
    recurringDebit,
    downloads,
    organizations,
    transactions,
    gateways,
    leads
  }
});

store.$axios = VueAxios;
store.i18n = i18n;

Vue.filter("momentUnix", (date, format) => {
  const { time_zone } = store.state.auth.user;
  return moment
    .unix(date)
    .utc()
    .tz(time_zone)
    .format(format);
});

export default store;
